<template>
  <div v-if="apiUser">
    <div class="layout__box__header layout__box__header--large-padding flex-wrap">
      <div class="w-100">
        <div class="d-flex justify-content-between align-items-top mb-2 flex-wrap admin-page__box__header">
          <h3 class="mt-1">
            {{ $t("reseller") }}
          </h3>
          <div
            class="btn btn-sm btn-primary d-flex align-items-center justify-content-center disabled"
            @click="newErrorVisible = true"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/ico-ico-plus-white.svg" />
            </div>
            {{ $t("novyReseller") }}
          </div>
          <div class="w-100 admin-page__box__select invisible mb-5">
            <div v-if="selectedReseller && resellers">
              <CustomSelect
                :items="resellers"
                :selected-item="selectedReseller"
                :name="'resellerName'"
                :medium="true"
                @select-item="selectReseller"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="layout__box__content admin-page__box__list">
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-menu-user-gray.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("informaceOSpravci") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("sluzbyALimity") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-sprava-uzivatelu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("spravaUzivatelu") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer link-no-style"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-tag-gray.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("spravaTaguAParametru") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("workflowManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-zmenitsluzbu-disabled.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("payloadManazer") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
      <RouterLink
        :to="{ name: 'adminResellerLogs' }"
        class="admin-page__box__link w-100 d-flex pointer link-no-style"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-log-operaci.svg" />
          </div>
          <span class="font-weight-light">{{ $t("logOperaci") }}</span>
        </div>
      </RouterLink>
      <div
        class="admin-page__box__link admin-page__box__link--inactive w-100 d-flex pointer"
        :class="{ disabledClick: !apiUser.isIotAdmin }"
      >
        <div class="admin-page__box__link__innerWrap">
          <div class="atom-icon">
            <img src="@/assets/icons/admin/ico-ico-prehled-zakazniku-gray.svg" />
          </div>
          <span class="font-weight-light gray-text-light">{{ $t("prehledVsechZakazniku") }}</span>
        </div>
        <span class="atom-tag atom-tag--success">{{ $t("pripravujeme") }}</span>
      </div>
    </div>
    <div v-if="newErrorVisible">
      <ErrorModal :opened="true" :centered="true" @close="newErrorVisible = false" />
    </div>
  </div>
</template>

<script>
import ErrorModal from "@/components/confirmations/contactManager.vue"
import Select from "@/components/inputs/select.vue"
import { useCustomerStore } from "@/store/modules/customer"
import { useAuthStore } from "@/store/modules/auth"
import { useAdminStore } from "@/store/modules/admin"

export default {
  components: {
    CustomSelect: Select,
    ErrorModal
  },
  props: {},
  setup() {
    const authStore = useAuthStore()
    const adminStore = useAdminStore()

    return { authStore, adminStore }
  },
  data() {
    console.log("data")
    return {
      selectedReseller: {},
      newErrorVisible: false,
      resellers: [
        {
          resellerName: "Resseler 1",
          resellerId: "123456"
        },
        {
          resellerName: "Resseler 2",
          resellerId: "123457"
        }
      ]
    }
  },
  computed: {
    user() {
      return this.authStore.user
    },
    apiUser() {
      return this.authStore.apiUser
    },
    storedReseller() {
      return this.adminStore.reseller
    }
  },
  watch: {
    customer() {},
    resellers() {
      if (this.storedReseller) {
        this.selectedReseller = this.storedReseller
      } else {
        var res = localStorage.getItem("selectedAdminReseller")
        this.selectedReseller = res != undefined ? JSON.parse(res) : this.resellers[0]
      }
    },
    selectedReseller() {
      this.adminStore.setReseller(this.selectedReseller)
    }
  },
  mounted() {
    if (this.resellers) {
      if (this.storedReseller) {
        this.selectedReseller = this.storedReseller
      } else {
        var res = localStorage.getItem("selectedAdminReseller")
        this.selectedReseller = res != "undefined" ? JSON.parse(res) : this.resellers[0]
      }
    }
  },
  methods: {
    selectReseller(customer) {
      this.selectedReseller = customer
    }
  }
}
</script>
